import * as React from "react";
import {
  ChakraProvider,
  Box,
  Heading,
  Avatar,
  Switch,
  Stack,
  TableContainer,
  Table,
  Tbody,
  Tr,
  Td,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Skeleton,
  SkeletonCircle,
  useToast,
  Input,
  FormControl,
  FormLabel,
  Text,
  HStack,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  ModalBody,
  ModalFooter,
  Modal,
  ModalContent,
  ModalOverlay,
  ModalHeader,
  Button,
  Spacer,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { useAuth } from "../auth/useAuth";
//import { IoCameraOutline } from "react-icons/io5";
import { UserBonos } from "../components/Activity/UserBonos";
import { UserBookings } from "../components/Activity/UserBookings";
import { MdOutlineBook, MdOutlineLocalFireDepartment } from "react-icons/md";
import axios from "axios";
import { useEffect, useState } from "react";
import { IoIosArrowRoundForward } from "react-icons/io";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import FlagEs from "../images/flags/flag-es.svg";
import FlagCa from "../images/flags/flag-ca.svg";
import FlagUk from "../images/flags/flag-uk.svg";

export function Profile() {
  const auth = useAuth();
  const options = { year: "2-digit", month: "2-digit", day: "2-digit" };
  const [user, setUser] = useState(null);
  const [isConfigDisabled, setIsConfigDisabled] = useState(false);
  const [avatarModal, setAvatarModal] = useState(false);
  const toast = useToast();
  const { t, i18n } = useTranslation();
  const currentLanguage = (i18n.language || "es").split("-")[0];
  const languageLabelMap = {
    es: "ES",
    ca: "CA",
    en: "EN",
  };
  const languageFlagMap = {
    es: FlagEs,
    ca: FlagCa,
    en: FlagUk,
  };
  const currentLanguageLabel =
    languageLabelMap[currentLanguage] || languageLabelMap.es;
  const currentLanguageFlag =
    languageFlagMap[currentLanguage] || languageFlagMap.es;
  const locale = i18n.language?.startsWith("ca")
    ? "ca-ES"
    : i18n.language?.startsWith("en")
    ? "en-GB"
    : "es-ES";

  useEffect(() => {
    (async () => {
      const { data } = await axios.get("/api/user");
      setUser(data);
    })();
  }, []);

  function getDate(d) {
    let date = new Date(d);
    return new Intl.DateTimeFormat(locale, options).format(date);
  }

  function getGender(g) {
    return g === "MALE" ? t("profile.gender.male") : t("profile.gender.female");
  }

  function phoneFormat(numero) {
    // Elimina cualquier carácter que no sea un dígito
    const numeroLimpio = numero.replace(/\D/g, "");

    // Verifica si el número tiene al menos 9 dígitos (incluyendo el prefijo +34)
    if (numeroLimpio.length < 9) {
      return t("profile.phoneInvalid");
    }

    // Extrae el prefijo y el número restante
    const prefijo = numeroLimpio.slice(0, 2);
    const resto = numeroLimpio.slice(2);

    // Aplica el formato deseado
    const formatoTelefono = `+${prefijo} ${resto.match(/.{1,3}/g).join(" ")}`;

    return formatoTelefono;
  }

  function handleLanguageChange(language) {
    i18n.changeLanguage(language);
  }

  async function handleEmailNotifChange() {
    setIsConfigDisabled(true);
    await axios
      .put("/api/user/config", {
        emailNotifEnabled: !user.emailNotifEnabled,
        showAttendance: user.showAttendance,
      })
      .then(() => {
        toast({
          title: t("profile.toastConfigUpdated"),
          description: t("profile.toastEmailNotifUpdated"),
          position: "bottom-right",
          duration: 3000,
          isClosable: true,
        });
        setUser({ ...user, emailNotifEnabled: !user.emailNotifEnabled });
      })
      .catch((error) => {
        toast({
          title: t("common.unexpectedErrorTitle"),
          description: error.response.data.message,
          status: "error",
          position: "bottom-right",
          duration: 3000,
          isClosable: true,
        });
      });

    setIsConfigDisabled(false);
  }

  async function handleShowAttendanceEnabled() {
    setIsConfigDisabled(true);

    await axios
      .put("/api/user/config", {
        emailNotifEnabled: user.emailNotifEnabled,
        showAttendanceEnabled: !user.showAttendanceEnabled,
      })
      .then(() => {
        toast({
          title: t("profile.toastConfigUpdated"),
          description: t("profile.toastAttendanceUpdated"),
          position: "bottom-right",
          duration: 3000,
          isClosable: true,
        });
        setUser({
          ...user,
          showAttendanceEnabled: !user.showAttendanceEnabled,
        });
      })
      .catch((error) => {
        toast({
          title: t("common.unexpectedErrorTitle"),
          description: error.response.data.message,
          status: "error",
          position: "bottom-right",
          duration: 3000,
          isClosable: true,
        });
      });

    setIsConfigDisabled(false);
  }

  function uploadAvatar(value) {
    if (value === null) {
      setAvatarModal(false);
      return;
    }

    if (value) {
      setIsLoading(true);

      const formData = new FormData();
      formData.append("file", file);

      axios
        .put("/api/user/avatar", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          toast({
            title: t("profile.toastAvatarUpdated"),
            description: "",
            position: "bottom-right",
            duration: 3000,
            isClosable: true,
          });

          setAvatarModal(false);
          setIsLoading(false);
          setFile(null);
          auth.updateUserAvatar(response.data);
        })
        .catch((error) => console.error("Error al actualizar avatar", error));
    } else {
      // TODO: do this
      console.log("eliminar");
    }
  }

  const [file, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
  const [isDeleteLoading, setIsDeleteLoading] = useState(null);
  const [error, setError] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const maxSize = 1 * 1024 * 1024; // 1MB en bytes

    if (file.size > maxSize) {
      setError(t("profile.avatarFileTooLarge"));
      return;
    } else {
      setError(null);
    }

    if (file && file.size < maxSize) {
      setFile(file);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (file) {
      uploadAvatar(file);
    }
  };

  const deleteAvatar = () => {
    setIsDeleteLoading(true);
    axios
      .delete("/api/user/avatar")
      .then(() => {
        toast({
          title: t("profile.toastAvatarDeleted"),
          description: "",
          position: "bottom-right",
          duration: 3000,
          isClosable: true,
        });

        setAvatarModal(false);
        setIsDeleteLoading(false);
        setFile(null);
        auth.updateUserAvatar("");
      })
      .catch((error) => console.error("Error al actualizar avatar", error));
  };

  return (
    <>
      <Helmet>
        <title>{t("profile.metaTitle")}</title>
        <meta
          name="description"
          content={t("profile.metaDescription")}
        />
      </Helmet>
      <ChakraProvider>
        <ModalAvatar
          isOpen={avatarModal}
          onClose={avatarModal}
          returnFocusOnClose={false}
        />
        <Box
          pt={"20px"}
          textAlign="justify"
          margin={"auto"}
          width={{ base: "100%", sm: "100%", md: "80%" }}
          maxW="1300px"
        >
          <Stack
            className="prevent-select"
            justifyContent={{ base: "center", sm: "center", md: "flex-end" }}
            display={{ base: "flex", sm: "flex", md: "none", lg: "none" }}
          >
            {!user ? (
              <Stack spacing={6} pt={5}>
                <Skeleton width={"250px"} height={"45px"} m="auto" />
                <SkeletonCircle
                  w={{ base: "130px", sm: "150px", md: "260px" }}
                  h={{ base: "130px", sm: "150px", md: "260px" }}
                  m="auto"
                />
              </Stack>
            ) : (
              <>
                <Heading
                  fontFamily={"Oswald"}
                  fontWeight={400}
                  fontSize={{ base: "4xl", sm: "4xl", md: "5xl" }}
                  lineHeight={"110%"}
                  color={"gray.800"}
                  pt={4}
                  pb={6}
                  textAlign={"center"}
                >
                  {t("profile.greeting", { name: user && user.name })}
                </Heading>
                <Avatar
                  size="xl"
                  w={{ base: "130px", sm: "150px", md: "260px" }}
                  h={{ base: "130px", sm: "150px", md: "260px" }}
                  name={`${auth.user.name} ${auth.user.surname1}`.trim()}
                  src={auth.user.avatar}
                  border="2px solid gray"
                  m="auto"
                  _hover={{
                    cursor: "pointer",
                    blur: "20px !important",
                  }}
                  onClick={() => setAvatarModal(true)}
                />
              </>
            )}
          </Stack>

          <TableContainer w={"100%"} maxW="1300px" m="auto" pb={8}>
            <Table variant="simple" size="md">
              <Tbody>
                <Tr display={{ base: "none", sm: "none", md: "table-row" }}>
                  <Td>
                    <Skeleton
                      isLoaded={user}
                      width={{ md: "300px", xl: "500px" }}
                    >
                      <Heading
                        fontFamily={"Oswald"}
                        fontWeight={400}
                        fontSize={{
                          base: "40px",
                          md: "45px",
                          lg: "50px",
                          xl: "55px",
                        }}
                        lineHeight={"110%"}
                        color={"gray.800"}
                      >
                        {t("profile.greeting", { name: user && user.name })}
                      </Heading>
                    </Skeleton>
                  </Td>
                  <Td isNumeric>
                    <SkeletonCircle size={24} isLoaded={user} m="auto" mr={0}>
                      <Avatar
                        size={{ base: "md", sm: "md", md: "xl" }}
                        name={`${auth.user.name} ${auth.user.surname1}`.trim()}
                        right={0}
                        src={auth.user.avatar}
                        border="2px solid gray"
                        _hover={{
                          cursor: "pointer",
                          blur: "20px",
                        }}
                        onClick={() => setAvatarModal(true)}
                      />
                    </SkeletonCircle>
                  </Td>
                </Tr>

                <Tr>
                  <Td pr={0}>{t("profile.fields.name")}</Td>
                  <Td pl={0} isNumeric>
                    <Skeleton isLoaded={!!user}>
                      {user ? user.name : t("profile.emptyValue")}
                    </Skeleton>
                  </Td>
                </Tr>

                <Tr>
                  <Td pr={0}>{t("profile.fields.surnames")}</Td>
                  <Td pl={0} isNumeric>
                    <Skeleton isLoaded={!!user}>
                      {user
                        ? user.surname1 + " " + user.surname2
                        : t("profile.emptyValue")}
                    </Skeleton>
                  </Td>
                </Tr>
                <Tr>
                  <Td pr={0}>{t("profile.fields.birthdate")}</Td>
                  <Td pl={0} isNumeric>
                    <Skeleton isLoaded={!!user}>
                      {user ? getDate(user.birthday) : t("profile.emptyValue")}
                    </Skeleton>
                  </Td>
                </Tr>
                <Tr>
                  <Td pr={0}>{t("profile.fields.phone")}</Td>
                  <Td pl={0} isNumeric>
                    <Skeleton isLoaded={!!user}>
                      {user
                        ? phoneFormat(user.phone)
                        : t("profile.emptyValue")}
                    </Skeleton>
                  </Td>
                </Tr>
                <Tr>
                  <Td pr={0}>{t("profile.fields.gender")}</Td>
                  <Td pl={0} isNumeric>
                    <Skeleton isLoaded={!!user}>
                      {user ? getGender(user.gender) : t("profile.emptyValue")}
                    </Skeleton>
                  </Td>
                </Tr>
                <Tr>
                  <Td pr={0} style={{maxHeight: 53, height: 53, paddingTop: 0, paddingBottom: 0}}>{t("profile.fields.language")}</Td>
                  <Td pl={0} isNumeric style={{maxHeight: 53, height: 53, paddingTop: 0, paddingBottom: 0}}>
                    <HStack justify="flex-end" height="53px" maxH="53px">
                      <Menu placement="bottom-end">
                        <MenuButton
                          as={Button}
                          rounded={"full"}
                          variant={"link"}
                          cursor={"pointer"}
                          style={{ textDecoration: "none" }}
                          minW={0}
                        >
                          <HStack spacing={1.5}>
                            <Avatar
                              border="2px solid gray"
                              size="xs"
                              src={currentLanguageFlag}
                              name={currentLanguageLabel}
                              bg="gray.100"
                            />
                            <ChevronDownIcon color="gray.600" mt={0.5} />
                          </HStack>
                        </MenuButton>
                        <MenuList
                          borderRadius={0}
                          color="black"
                          maxW="140px"
                          minW="140px"
                        >
                          <MenuItem onClick={() => handleLanguageChange("es")}> 
                            {t("navbar.language.es")}
                          </MenuItem>
                          <MenuItem onClick={() => handleLanguageChange("ca")}> 
                            {t("navbar.language.ca")}
                          </MenuItem>
                          <MenuItem onClick={() => handleLanguageChange("en")}> 
                            {t("navbar.language.en")}
                          </MenuItem>
                        </MenuList>
                      </Menu>
                    </HStack>
                  </Td>
                </Tr>
                <Tr>
                  <Td pr={0}>{t("profile.fields.emailNotifications")}</Td>
                  <Td pl={0}>
                    <Switch
                      size="md"
                      isChecked={user ? user.emailNotifEnabled : false}
                      display="flex"
                      justifyContent="right"
                      onChange={handleEmailNotifChange}
                      isDisabled={isConfigDisabled}
                    />
                  </Td>
                </Tr>
                <Tr>
                  <Td pr={0}>{t("profile.fields.showAttendance")}</Td>
                  <Td pl={0}>
                    <Switch
                      size="md"
                      isChecked={user ? user.showAttendanceEnabled : false}
                      display="flex"
                      justifyContent="right"
                      onChange={handleShowAttendanceEnabled}
                      isDisabled={isConfigDisabled}
                    />
                  </Td>
                </Tr>
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
        <Box
          width={{ base: "100%", sm: "100%", md: "80%" }}
          maxW="1300px"
          m="auto"
        >
          <Heading
            fontFamily={"Oswald"}
            fontWeight={400}
            fontSize={{ base: "4xl", sm: "4xl", md: "5xl" }}
            lineHeight={"110%"}
            color={"gray.800"}
            textAlign={"center"}
            px={5}
            pb={6}
          >
            {t("profile.activityHeading")}
          </Heading>
        </Box>
        <Box pb={5}>
          <Tabs isFitted isLazy lazyBehavior="keepMounted">
            <TabList
              width={{ base: "100%", sm: "100%", md: "80%" }}
              maxW="1300px"
              m="auto"
            >
              <Tab>
                <MdOutlineLocalFireDepartment />
                &nbsp;{t("profile.tabs.bonos")}
              </Tab>
              <Tab>
                <MdOutlineBook />
                &nbsp;{t("profile.tabs.bookings")}
              </Tab>
            </TabList>

            <TabPanels>
              <TabPanel className="p0-tab-panel">
                <UserBonos bonoEdit={false}/>
              </TabPanel>
              <TabPanel className="p0-tab-panel">
                <UserBookings />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
      </ChakraProvider>
    </>
  );

  function ModalAvatar({ isOpen }) {
    return (
      <>
        <Modal
          onClose={() => setAvatarModal(false)}
          isOpen={isOpen}
          isCentered
          size="sm"
          borderRadius={"0px"}
          closeOnOverlayClick={!(isLoading || isDeleteLoading)}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader textAlign="left" mt={2}>
              <Text>{t("profile.avatarModal.title")}</Text>
            </ModalHeader>
            <form onSubmit={handleSubmit} m="aut<o">
              <ModalBody>
                <Stack spacing={4}>
                  <HStack spacing={5} justifyContent="center">
                    <Avatar
                      size="xl"
                      border="2px solid var(--chakra-colors-gray-300)"
                      name={`${auth.user.name} ${auth.user.surname1}`.trim()}
                      src={auth.user.avatar}
                    />
                    <IoIosArrowRoundForward size="1.5em" color="gray" />
                    <Avatar
                      size="xl"
                      border="2px solid var(--chakra-colors-gray-300)"
                      src={file && URL.createObjectURL(file)}
                      alt={t("profile.avatarModal.previewAlt")}
                    />
                  </HStack>

                  <Box w="100%">
                    <FormControl>
                      <Stack
                        id="dropContainer"
                        onDrop={(evt) => {
                          setFile(evt.dataTransfer.files[0]);
                          evt.preventDefault();
                        }}
                        onDragOver={(e) => e.preventDefault()}
                        justifyContent={"center"}
                        w="auto"
                        _hover={{
                          bg: "gray.200;",
                        }}
                      >
                        <FormLabel
                          html="files"
                          textAlign="center"
                          cursor="pointer"
                          py={8}
                          px={1}
                          fontWeight="300"
                          border="1px solid var(--chakra-colors-gray-100)"
                          m={0}
                        >
                          {file
                            ? file.name
                            : t("profile.avatarModal.dropHint")}

                          {error ? (
                            <Text fontSize="sm" mt={1} color="red">
                              {error}
                            </Text>
                          ) : (
                            <Text fontSize="sm" mt={1}>
                              {t("profile.avatarModal.fileTypes")}
                            </Text>
                          )}
                        </FormLabel>
                      </Stack>
                      <Input
                        type="file"
                        onChange={handleFileChange}
                        accept=".jpg,.jpeg,.png"
                        display="none"
                      />
                    </FormControl>
                  </Box>
                </Stack>
              </ModalBody>

              <ModalFooter pt={2}>
                <Button
                  onClick={() => {
                    setAvatarModal(false);
                    setFile(null);
                    setError(null);
                  }}
                  borderRadius={0}
                  display={"flex"}
                  justifyContent={"flex-end"}
                  mr={2}
                  isDisabled={isLoading || isDeleteLoading}
                >
                  {t("common.cancel")}
                </Button>
                <Spacer />
                <HStack spacing={2}>
                  <Button
                    onClick={() => deleteAvatar()}
                    colorScheme="red"
                    borderRadius={0}
                    isDisabled={!auth.user.avatar || isLoading}
                    isLoading={isDeleteLoading}
                  >
                    {t("profile.avatarModal.delete")}
                  </Button>
                  s{" "}
                  <Button
                    type="submit"
                    colorScheme="blue"
                    borderRadius={0}
                    variant="outline"
                    isDisabled={!file || isDeleteLoading}
                    isLoading={isLoading}
                  >
                    {t("profile.avatarModal.publish")}
                  </Button>
                </HStack>
              </ModalFooter>
            </form>
          </ModalContent>
        </Modal>
      </>
    );
  }
}

export default Profile;
